import { useCallback } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';

export const useGetCurrencySymbol = () => {
  const { c } = useI18n();
  const { isDisplayCurrencySymbol = false } = useOtherSettings();

  return useCallback(
    (currency = '') =>
      isDisplayCurrencySymbol ? c.formatCurrencySymbol(currency) : currency,
    [c, isDisplayCurrencySymbol]
  );
};
